module.exports = __webpack_public_path__ + "static/earth-action-trust-2f94e87acdbc1720dd01a0eb7ebc5638.jpg";